import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-trigger-app-preview',
    templateUrl: './trigger-app-preview.component.html',
    styleUrls: ['./trigger-app-preview.component.scss'],
})
export class TriggerAppPreviewComponent implements OnInit {
    @Input() public form2: UntypedFormGroup;
    @Input() public form3: UntypedFormGroup;
    @Input() public isModalFS: boolean;
    @Input() public isModalSimple: boolean;
    @Input() public isBox: boolean;
    @Input() public data: boolean;
    constructor() {}

    ngOnInit() {}
}
